import { FC } from "react";

import MobileHeaderTitle from "../MobileHeaderTitle";

const MobileHeaderMain: FC = () => <div className="header-mobile__main">
  <MobileHeaderTitle/>
</div>;

export default MobileHeaderMain;